// All company services
export const SERVICES = [
  { id: 'ai-dev', label: 'AI Development', color: 'bg-blue-100 text-blue-800' },
  { id: 'ai-ml', label: 'AI/ML & Generative', color: 'bg-purple-100 text-purple-800' },
  { id: 'ai-startups', label: 'AI for Startups', color: 'bg-indigo-100 text-indigo-800' },
  { id: 'web-dev', label: 'Web Development', color: 'bg-green-100 text-green-800' },
  { id: 'mobile-dev', label: 'Mobile Development', color: 'bg-cyan-100 text-cyan-800' },
  { id: 'cloud-dev', label: 'Cloud Development', color: 'bg-orange-100 text-orange-800' },
  { id: 'business-intel', label: 'Business Intelligence', color: 'bg-red-100 text-red-800' },
  { id: 'digital-transform', label: 'Digital Transformation', color: 'bg-pink-100 text-pink-800' },
  { id: 'consulting', label: 'Consulting', color: 'bg-yellow-100 text-yellow-800' },
  { id: 'media-tech', label: 'Media Technology', color: 'bg-teal-100 text-teal-800' },
  { id: 'voice-telecom', label: 'Voice & Telecom', color: 'bg-slate-100 text-slate-800' },
  { id: 'vibe-coding', label: 'Vibe Coding', color: 'bg-fuchsia-100 text-fuchsia-800' },
];

// Comprehensive list of technologies by category
export const TECHNOLOGY_CATEGORIES = {
  'Frontend': [
    'React', 'Vue.js', 'Angular', 'Svelte', 'Next.js', 'Nuxt.js', 'Astro',
    'TypeScript', 'JavaScript', 'HTML5', 'CSS3', 'Tailwind CSS', 'Bootstrap',
    'Webpack', 'Vite', 'Gatsby', 'Remix', 'SolidJS', 'Preact', 'Alpine.js'
  ],
  'Backend': [
    'Node.js', 'Python', 'Django', 'Flask', 'FastAPI', 'Java', 'Spring Boot',
    'C#', '.NET', 'Go', 'Rust', 'PHP', 'Laravel', 'Symfony', 'Ruby', 'Rails',
    'Elixir', 'Erlang', 'Kotlin', 'Scala', 'Clojure'
  ],
  'Mobile': [
    'React Native', 'Flutter', 'Swift', 'Kotlin', 'Java', 'Objective-C',
    'Xamarin', 'NativeScript', 'Ionic', 'Cordova', 'PWA'
  ],
  'Cloud & DevOps': [
    'AWS', 'Azure', 'Google Cloud', 'Cloudflare', 'Docker', 'Kubernetes',
    'Terraform', 'Ansible', 'CI/CD', 'GitHub Actions', 'GitLab CI', 'Jenkins',
    'Vercel', 'Netlify', 'Heroku', 'DigitalOcean', 'Linode'
  ],
  'Databases': [
    'PostgreSQL', 'MySQL', 'MongoDB', 'Redis', 'Elasticsearch', 'Firebase',
    'Supabase', 'DynamoDB', 'Cassandra', 'Neo4j', 'CouchDB', 'RethinkDB',
    'SQLite', 'MariaDB', 'Oracle', 'SQL Server'
  ],
  'AI/ML': [
    'ChatGPT', 'GPT-4', 'Claude', 'Gemini', 'LangChain', 'LlamaIndex',
    'OpenAI API', 'Anthropic', 'TensorFlow', 'PyTorch', 'scikit-learn',
    'Pandas', 'NumPy', 'XGBoost', 'Hugging Face', 'Ollama'
  ],
  'Design & CMS': [
    'Figma', 'Adobe XD', 'Sketch', 'WordPress', 'Contentful', 'Strapi',
    'Sanity', 'Webflow', 'Payload CMS', 'Ghost', 'Wix', 'Shopify'
  ],
  'Testing & QA': [
    'Jest', 'Cypress', 'Selenium', 'Playwright', 'Vitest', 'Mocha',
    'Testing Library', 'Postman', 'SoapUI', 'LoadRunner', 'JMeter'
  ],
  'Tools & Services': [
    'Git', 'GitHub', 'GitLab', 'Bitbucket', 'Jira', 'Notion', 'Slack',
    'Stripe', 'PayPal', 'Twilio', 'SendGrid', 'Auth0', 'Firebase Auth'
  ],
};

// Budget options
export const BUDGET_OPTIONS = [
  '$10,000 - $50,000',
  '$50,000 - $100,000',
  '$100,000 - $250,000',
  '$250,000+',
];

// Timeline options
export const TIMELINE_OPTIONS = [
  'ASAP',
  '1-3 months',
  '3-6 months',
  '6+ months',
];

// Project status options
export const PROJECT_STATUS_OPTIONS = [
  { value: 'idea', label: 'Idea' },
  { value: 'mvp', label: 'MVP' },
  { value: 'product', label: 'Existing product' },
  { value: 'scale', label: 'Scaling' },
];

// Platform options
export const PLATFORMS_OPTIONS = [
  { value: 'web', label: 'Web' },
  { value: 'mobile', label: 'Mobile' },
  { value: 'desktop', label: 'Desktop' },
  { value: 'api', label: 'API' },
  { value: 'iot', label: 'IoT' },
];

// Simple platforms list for survey
export const PLATFORMS = ['Web', 'Mobile', 'Desktop', 'API', 'IoT'];

// Development stages
export const DEVELOPMENT_STAGES = [
  { value: 'planning', label: 'Planning / Discovery' },
  { value: 'design', label: 'Design' },
  { value: 'development', label: 'Development' },
  { value: 'testing', label: 'Testing' },
  { value: 'production', label: 'Production' },
  { value: 'maintenance', label: 'Maintenance & Improvements' },
];

// Combined list of all technologies for search
export const ALL_TECHNOLOGIES = Object.values(TECHNOLOGY_CATEGORIES).flat();
